import React from 'react';
import { defaultTemplate } from 'core/hoc';

const BasicCheckboxTemplate = ({
	field,
	id,
	label,
	checked,
	className = 'input input--check',
	onChangeCallback,
	t,
	disabled,
	additionalLabel
}) => {
	let props = {};
	if (field) {
		props = { ...field.bind() };
		props.disabled = disabled;
		({ id, label } = field);
		if (onChangeCallback) {
			props.onChange = e => {
				field.onChange(e);
				onChangeCallback(e);
			};
		}
	} else {
		props = { onChange: onChangeCallback, checked, disabled, id };
	}
	return (
		<React.Fragment>
			<input data-cy={`${id}-checkbox`} type="checkbox" className={className} {...props} />
			<label className="spc--right--tny" htmlFor={id} data-cy={`${id}-label`}>
				{t(label)}
			</label>
			{additionalLabel && additionalLabel()}
		</React.Fragment>
	);
};

export default defaultTemplate(BasicCheckboxTemplate);
